<script>
import { BLink } from "bootstrap-vue";

export default {
  extends: BLink
};
</script>